const removePtag = (code: string) => {
  return code.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '\n')
}

const replaceBrTag = (code: string) => {
  return code.replace(/<br\s*\/?>/gi, '\n')
}

const removePreTag = (code: string) => {
  return code.replace(/<pre[^>]*>/g, '').replace(/<\/pre>/g, '')
}

const removeZeroWidthSpaces = (code: string) => {
  return code.replace(/&#8203;/g, '')
}

const removeHTMLentityEncoding = (code: string) => {


  return code.replace(/&(nbsp|gt|lt|Aring|aring|AElig|aelig|Oslash|oslash);/gi, (match) => {
    switch (match) {
      case '&nbsp;':
        return ' '
      case '&gt;':
        return '>'
      case '&lt;':
        return '<'
      case '&Aring;':
        return 'Å'
      case '&aring;':
        return 'å'
      case '&AElig;':
        return 'Æ'
      case '&aelig;':
        return 'æ'
      case '&Oslash;':
        return 'Ø'
      case '&oslash;':
        return 'ø'
      default:
        return match
    }
  }
  )
}
export const decodeHtmlString = (input: string | null) => {
  if (!input) return ''

  let cleaned = removePtag(input)
  cleaned = replaceBrTag(cleaned)
  cleaned = removePreTag(cleaned)
  cleaned = removeZeroWidthSpaces(cleaned)
  cleaned = removeHTMLentityEncoding(cleaned)
  return cleaned
}
